import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'em-zoom-controls',
  templateUrl: './zoom-controls.component.html',
  styleUrl: './zoom-controls.component.css'
})
export class ZoomControlsComponent {

@Input() zoomLevel = 100;
@Output() zoomChange = new EventEmitter<number>();

zoomIn() {
  this.zoomLevel = Math.min(this.zoomLevel + 10, 300);
  this.zoomChange.emit(this.zoomLevel);
}

zoomOut() {
  this.zoomLevel = Math.max(this.zoomLevel - 10, 10);
  this.zoomChange.emit(this.zoomLevel);
}

resetZoom() {
  this.zoomLevel = 30;
  this.zoomChange.emit(this.zoomLevel);
}

}
